import React, { useContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import {
  Container,
  InputsContainer,
  Label,
  Option,
  Select,
  SubContainer,
  SelectWrapper
} from './styles'

import FormInput from '../../components/FormInput';
import Button from '../../components/Button';

import Context, { IContext } from '../../context/Context';
import { IProfissional } from '../../types/Profissional';
import api from '../../services/api';
import { IEspaco } from '../../types/Espaco';


export default function AgendarCompromisso() {
  const navigate = useNavigate();
  const { setIsLoadingOverlay }: IContext = useContext(Context);
  const inputDatIniRef = useRef<HTMLInputElement>(null);
  const inputDatFinRef = useRef<HTMLInputElement>(null);
  const inputHorarioRef = useRef<HTMLInputElement>(null);
  const pressTimer = useRef<number | null>(null);
  const diasDaSemana = ['Domingo', 'Segunda', 'Terca', 'Quarta', 'Quinta', 'Sexta', 'Sabado'];

  const [datIni, setDatIni] = useState('');
  const [datFin, setDatFin] = useState('');
  const [diaDaSemanaSelecionado, setDiaDaSemanaSelecionado] = useState('');
  const [profissional, setProfissional] = useState<IProfissional[]>([]);
  const [profissionalSelecionado, setProfissionalSelecionado] = useState('');
  const [espacos, setEspacos] = useState<IEspaco[]>([]);
  const [espacoSelecionado, setEspacoSelecionado] = useState('');
  const [horarioSelecionado, setHorarioSelecionado] = useState('');
  const [obs, setObs] = useState('');

  const [isDebugMode, setIsDebugMode] = useState(false);


  const handleMouseDown = () => {
    pressTimer.current = window.setTimeout(() => {
      setIsDebugMode(!isDebugMode);
    }, 3000); // 3 segundos
  };

  const handleMouseUp = () => {
    if (pressTimer.current) {
      clearTimeout(pressTimer.current);
      pressTimer.current = null;
    }
  };

  const handleMouseLeave = () => {
    if (pressTimer.current) {
      clearTimeout(pressTimer.current);
      pressTimer.current = null;
    }
  };

  async function getData() {
    try {
      setIsLoadingOverlay(true);

      const [profissionaisResponse, espacosResponse] = await Promise.all([
        api.get('/profissionais'),
        api.get('/espacos')
      ])

      if (profissionaisResponse.status === 200) {
        setProfissional(profissionaisResponse.data);
      }

      if (espacosResponse.status === 200) {
        setEspacos(espacosResponse.data);
      }

    } catch (error) {
      toast.error('Erro ao buscar dados');
    } finally {
      setTimeout(() => {
        setIsLoadingOverlay(false);
      }, 500);
    }
  }

  async function agendarCompromissoFixo(codent: string | number, tipent: 'Profissional' | 'Espaco') {
    if (!codent) return;
    if (!tipent) return;
    if (!profissionalSelecionado && !espacoSelecionado) return;
    if (!diasDaSemana) return;
    if (!horarioSelecionado) return;

    try {
      if (datIni === datFin) {
        const indexDiaDaSemana = new Date(datIni).getDay();

        if (diasDaSemana[indexDiaDaSemana + 1] !== diaDaSemanaSelecionado) {
          throw new Error(`Dia da Semana Inválido. esperado: ${diasDaSemana[indexDiaDaSemana + 1]}`);
        }
      }

      setIsLoadingOverlay(true);

      if (isDebugMode) alert('Começou envio de compromisso fixo');

      const horfinSplit = horarioSelecionado.split(':');

      let horfin = `${+horfinSplit[0] + 1}:${horfinSplit[1]}`;

      const payload = {
        codent: +codent,
        tipent,
        diasem: diaDaSemanaSelecionado,
        horini: horarioSelecionado,
        horfin,
        datini: datIni,
        datfin: datFin,
        obs
      }

      await api.post('/compromissosFixos', payload);

      if (isDebugMode) alert('Finalizou POST');

    } catch (error: any) {
      toast.error('Erro ao agendar compromisso. ' + error?.message || '');

      if (error?.response.data?.erro) {
        toast.error(error.response.data.erro);
        return;
      }

    } finally {
      if (isDebugMode) alert('Entrou no finally');
      if (isDebugMode) alert('Finalizou agendarCompromissoFixo()');
    }
  }

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const promises = [];

    if (profissionalSelecionado) {
      promises.push(agendarCompromissoFixo(profissionalSelecionado, 'Profissional'));
    }

    if (espacoSelecionado) {
      promises.push(agendarCompromissoFixo(espacoSelecionado, 'Espaco'));
    }

    if (promises.length === 0) return;

    setIsLoadingOverlay(true);

    try {
      await Promise.all(promises);

      toast.success('Agendamentos realizados com sucesso!');

      setProfissionalSelecionado('');
      setEspacoSelecionado('');
      setHorarioSelecionado('');
      setDiaDaSemanaSelecionado('');
      setDatIni('');
      setDatFin('');
    } catch {
      // erros já tratados individualmente
    } finally {
      setTimeout(() => setIsLoadingOverlay(false), 500);
    }
  }


  function handleHorarioChange(e: React.ChangeEvent<HTMLInputElement>) {
    let [hour, minute] = e.target.value.split(':').map(Number);

    // Arredondar minutos
    if (minute < 15) {
      minute = 0;
    } else if (minute < 45) {
      minute = 30;
    } else {
      minute = 0;
      hour = (hour + 1) % 24;
    }

    const formattedTime = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
    setHorarioSelecionado(formattedTime);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Container
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleMouseDown}
      onTouchEnd={handleMouseUp}
    >
      <Button
        onClick={() => navigate('/controle')}
        style={{ minWidth: '10%', width: 'auto', alignSelf: 'center', backgroundColor: 'green' }}
      >
        Consultar Agendamentos
      </Button>
      <h1 translate='no'>Agendamento de Compromissos Fixos{isDebugMode ? ' - Modo Debug' : ''}</h1>
      <SubContainer onSubmit={handleSubmit}>
        <SelectWrapper>
          <Label translate='no'>Professor(a):</Label>
          <Select required={!profissionalSelecionado && !espacoSelecionado} value={profissionalSelecionado} onChange={e => setProfissionalSelecionado(e.target.value)}>
            <Option value='' translate='no'>Nenhum Selecionado</Option>
            {profissional.map(profissional => (
              <Option key={profissional.cod} value={profissional.cod} translate='no'>{profissional.pro}</Option>
            ))}
          </Select>
        </SelectWrapper>
        <SelectWrapper>
          <Label translate='no'>Espaço:</Label>
          <Select required={!profissionalSelecionado && !espacoSelecionado} value={espacoSelecionado} onChange={e => setEspacoSelecionado(e.target.value)}>
            <Option value='' translate='no'>Nenhum Selecionado</Option>
            {espacos.map(espaco => (
              <Option key={espaco.cod} value={espaco.cod} translate='no'>{espaco.esp}</Option>
            ))}
          </Select>
        </SelectWrapper>
        <SelectWrapper>
          <Label translate='no'>Dia da Semana(a):</Label>
          <Select value={diaDaSemanaSelecionado} onChange={e => setDiaDaSemanaSelecionado(e.target.value)}>
            <Option value='' translate='no'>Nenhum Selecionado</Option>
            {diasDaSemana.map((dia, index) => (
              <Option key={index} value={dia} translate='no'>{dia}</Option>
            ))}
          </Select>
        </SelectWrapper>
        <InputsContainer>
          <Label translate='no'>Horário:</Label>
          <FormInput
            ref={inputHorarioRef}
            type='time'
            placeHolder=''
            step={1800}
            required
            onChange={handleHorarioChange}
            value={horarioSelecionado}
            onClick={() => inputHorarioRef?.current && inputHorarioRef.current.showPicker()}
          />
          <Label translate='no'>Data de Inicio:</Label>
          <FormInput
            ref={inputDatIniRef}
            placeHolder=''
            type='date'
            required={Boolean(datFin)}
            maxLength={14}
            onChange={e => {
              if (isNaN(new Date(e.target.value).getTime())) {
                setDatIni(new Date().toISOString().split('T')[0]);
                return;
              }

              setDatIni(e.target.value);
            }}
            onKeyDown={(e) => e.preventDefault()}
            value={datIni}
            onClick={() => inputDatIniRef?.current && inputDatIniRef.current.showPicker()}
          />
          <Label translate='no'>Data Final:</Label>
          <FormInput
            ref={inputDatFinRef}
            placeHolder=''
            type='date'
            maxLength={14}
            required={Boolean(datIni)}
            onChange={e => {
              if (isNaN(new Date(e.target.value).getTime())) {
                setDatFin(new Date().toISOString().split('T')[0]);
                return;
              }

              setDatFin(e.target.value);
            }}
            onKeyDown={(e) => e.preventDefault()}
            value={datFin}
            onClick={() => inputDatFinRef?.current && inputDatFinRef.current.showPicker()}
          />
          <Label translate='no'>Observação:</Label>
          <FormInput
            placeHolder=''
            onChange={e => setObs(e.target.value)}
            value={obs}
          />
        </InputsContainer>
        <Button
          type='submit'
          translate='no'
          style={{ marginTop: '10px', width: '50%' }}
        >
          Agendar
        </Button>

      </SubContainer>
    </Container>
  );
}
